import type { cv_ContainerType } from './cv-container-type.interface';

export interface cv_VolumeUnit {
    C_VocabularySource_key: number | null;
    C_VolumeUnit_key: number;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    SortOrder: number | null;
    Version: number;
    VolumeUnit: string;
    cv_ContainerType: cv_ContainerType[];
}
